// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__I4XIr","addWidgetButton":"Header_addWidgetButton__3lAh-","dashboardTabs":"Header_dashboardTabs__1eZmM","active":"Header_active__3GR35"};